import React from 'react';

import './styles.css'
import FaqQuestion from './question';

const FaqNew = ({ questions }) => (
  <section className="faq-container">
    <h5 className="faq-title">FAQ</h5>
    {questions.map(question => (
      <FaqQuestion question={question} key={question.question}/>
    ))}
  </section>
);

export default FaqNew;



// WEBPACK FOOTER //
// ./src/components/buy/table-checkouts/PackSelectorPage/FAQ/index.js